<div class="wrap-sort d-flex align-items-center">
  <div class="sort-text-wrap">
    <label>Sort by:</label>
    <select class="sort-options" id="companysort" (change)="sortCompanyList($event)">
      <option [selected]="true">{{selectedOption}}</option>
      <option *ngFor="let option of sortingOptions" [value]="option" [hidden]="option === selectedOption">{{option}}</option>
    </select>
  </div>
</div>
